<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs :crm_id="this.$route.params.id"/>
            <el-form
              :model="analysis"
              class="analysis"
              label-width="7em">
              <el-form-item label="背景分析：">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="analysis.backdrop"/>
              </el-form-item>
              <el-form-item label="学生心得：">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="analysis.student_study"/>
              </el-form-item>
              <el-form-item label="顾问点评：">
                <em>优势分析：</em>
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="analysis.superiority"
                  class="comments"/>
                <em>劣势分析：</em>
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="analysis.inferior"
                  class="comments"/>
                <em>综合评定：</em>
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="analysis.comprehensive"
                  class="comments"/>
              </el-form-item>
              <el-form-item label="Offer选择：">
                <em>选择展示的Offer申请：</em>
                <el-radio
                  v-model="analysis.offer_school_id"
                  :label="item.id"
                  v-for="item in analysis.offer_school"
                  :key="item.id">
                  学校：<span>{{ item.schoolname }}</span> - 专业：<span>{{ item.zhuanye_name }}</span> - 学位类型：<span>{{ item.xuewei_type }}</span> - 申请结果：<span>{{ item.shenqing_result > 1 ? '失败' : '成功' }}</span>
                </el-radio>
              </el-form-item>
              <el-form-item label="Offer设置：">
                <em>所选Offer申请是否在“成功案例”列表中显示：</em>
                <el-switch
                  v-model="analysis.isshow"
                  on-text="显示"
                  off-text="隐藏"/>
              </el-form-item>
              <el-form-item label="案例标题：">
                <el-input
                  v-model="analysis.case_title"
                  placeholder="请输入内容"/>
                <em>系统自动生成，可手动编辑</em>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="setAnalysis">重置</el-button>
                <el-button
                  type="primary"
                  @click="saveCase">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

let analysis = {
  offer_school_id: '',
  backdrop: '',
  student_study: '',
  superiority: '',
  inferior: '',
  comprehensive: '',
  isshow: false,
  case_title: ''
};

export default {
  data() {
    return {
      analysis: {}
    };
  },
  methods: {
    setAnalysis() {
      this.analysis = Object.assign({}, analysis);
    },
    saveCase() {
      this.$http
        ._post({
          url: `/index/offer_small/saveCase?crm_id=${this.$route.params.id}`,
          data: this.analysis
        })
        .then((res) => {
          this.$message({ message: res.msg, type: res.result !== 0 ? 'error' : 'success' });
          console.log(res);
        });
    }
  },
  created() {
    this.$http
      ._get({
        url: `/index/offer_small/showCase?crm_id=${this.$route.params.id}`
      })
      .then(({ data }) => {
        analysis = data;
        this.setAnalysis();
        this.id = this.analysis.offer_school_id;
        if (!this.analysis.case_title) {
          this.analysis.case_title = this.analysis.content[this.analysis.offer_school_id];
        }
      }, ({ data }) => {
        if (data.result < 0) {
          this.$alert('还没有OFFER', '', {
            confirmButtonText: '确定',
            callback: () => {
              this.$router.push({ name: 'editStudent', params: { id: this.$route.params.id } });
            }
          });
        }
      });
  },
  watch: {
    'analysis.offer_school_id'(id) {
      if (this.id !== id) {
        this.analysis.case_title = this.analysis.content[id];
        this.id = id;
      }
    }
  }
};
</script>
<style>
  .student .analysis {
    max-width: 1170px;
  }

  .student .analysis .el-form-item__label {
    color: #20A0FF;
  }

  .student .analysis .el-form-item__content em {
    color: #FF4949;
  }

  .student .analysis .comments {
    margin-bottom: 1em;
  }

  .student .analysis .el-radio {
    display: block;
    margin: .375em 0 .75em;
  }

  .student .analysis .el-radio + .el-radio {
    margin: 0 0 .75em 0;
  }

  .student .analysis .el-radio__label {
    color: #97A8BE;
  }

  .student .analysis .el-radio__label span {
    color: #000;
  }

</style>
